import React from 'react';
import './shared.css';

interface GeneralSettingsTabProps {
    handleForm: any;
}

const GeneralSettingsTab: React.FC<GeneralSettingsTabProps> = ({ handleForm }) => {
    return (
        <div className="general-settings-container">
            <div className="settings-section">
                <h3 className="section-title" data-icon="📝">Configurações Básicas</h3>

                <div className="row g-3">
                    <div className="col-12 col-md-6">
                        <div className="form-group">
                            <label htmlFor="name" className="form-label">Nome da Tag <span className="text-danger">*</span></label>
                            <input
                                type="text"
                                id="name"
                                name="name"
                                className={`form-control ${handleForm.touched.name && handleForm.errors.name ? 'error' : ''}`}
                                onChange={handleForm.handleChange}
                                onBlur={handleForm.handleBlur}
                                value={handleForm.values.name}
                                placeholder="ROS"
                            />
                            {handleForm.touched.name && handleForm.errors.name ? (
                                <div className="invalid-feedback d-block">{handleForm.errors.name}</div>
                            ) : null}
                        </div>
                    </div>

                    <div className="col-12 col-md-6">
                        <div className="form-group">
                            <label htmlFor="domain" className="form-label">Site <span className="text-danger">*</span></label>
                            <input
                                type="text"
                                id="domain"
                                name="domain"
                                className={`form-control ${handleForm.touched.domain && handleForm.errors.domain ? 'error' : ''}`}
                                onChange={handleForm.handleChange}
                                onBlur={handleForm.handleBlur}
                                value={handleForm.values.domain}
                                placeholder="exemplo.com.br"
                            />
                            {handleForm.touched.domain && handleForm.errors.domain ? (
                                <div className="invalid-feedback d-block">{handleForm.errors.domain}</div>
                            ) : null}
                        </div>
                    </div>
                </div>
            </div>

            <div className="settings-section">
                <h3 className="section-title" data-icon="🎛️">Status e Configurações</h3>

                <div className="row g-3">
                    <div className='col-12 col-md-6 col-lg-4'>
                        <div className="form-group">
                            <label htmlFor="enabled" className="form-label">Habilitar TAG?</label>
                            <select
                                id="enabled"
                                name="enabled"
                                className={`form-select ${handleForm.touched.enabled && handleForm.errors.enabled ? 'error' : ''}`}
                                onChange={handleForm.handleChange}
                                value={handleForm.values.enabled}
                            >
                                <option value="true">✅ Sim</option>
                                <option value="false">❌ Não</option>
                            </select>
                            {handleForm.touched.enabled && handleForm.errors.enabled ? (
                                <div className="invalid-feedback d-block">{handleForm.errors.enabled}</div>
                            ) : null}
                        </div>
                    </div>
                    <div className='col-12 col-md-6 col-lg-4'>
                        <div className="form-group">
                            <label htmlFor="debug" className="form-label">Modo Debug</label>
                            <select
                                id="debug"
                                name="debug"
                                className={`form-select ${handleForm.touched.debug && handleForm.errors.debug ? 'error' : ''}`}
                                onChange={handleForm.handleChange}
                                value={handleForm.values.debug}
                            >
                                <option value="false">❌ Desabilitado</option>
                                <option value="true">🔍 Habilitado</option>
                            </select>
                            {handleForm.touched.debug && handleForm.errors.debug ? (
                                <div className="invalid-feedback d-block">{handleForm.errors.debug}</div>
                            ) : null}
                        </div>
                    </div>
                    <div className='col-12 col-md-6 col-lg-4'>
                        <div className="form-group">
                            <label htmlFor="loadOnScroll" className="form-label">
                                Carregar Após Interação
                            </label>
                            <select
                                id="loadOnScroll"
                                name="loadOnScroll"
                                className={`form-select ${handleForm.touched.loadOnScroll && handleForm.errors.loadOnScroll ? 'error' : ''}`}
                                onChange={handleForm.handleChange}
                                value={handleForm.values.loadOnScroll}
                            >
                                <option value="false">❌ Não</option>
                                <option value="true">🔄 Sim</option>
                            </select>
                            {handleForm.touched.loadOnScroll && handleForm.errors.loadOnScroll ? (
                                <div className="invalid-feedback d-block">{handleForm.errors.loadOnScroll}</div>
                            ) : null}
                        </div>
                    </div>
                </div>

                <div className='row g-3'>
                    <div className='col-12 col-md-6 col-lg-4'>
                        <div className="form-group">
                            <label htmlFor="lazyLoad" className="form-label">
                                Lazy Loading
                            </label>
                            <select
                                id="lazyLoad"
                                name="lazyLoad"
                                className={`form-select ${handleForm.touched.lazyLoad && handleForm.errors.lazyLoad ? 'error' : ''}`}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    if (value === 'false') {
                                        handleForm.setFieldValue('lazyLoad', null);
                                    } else {
                                        handleForm.setFieldValue('lazyLoad', {
                                            fetchMarginPercent: handleForm.values.lazyLoad?.fetchMarginPercent || 200,
                                            renderMarginPercent: handleForm.values.lazyLoad?.renderMarginPercent || 100,
                                            mobileScaling: handleForm.values.lazyLoad?.mobileScaling || 2.0
                                        });
                                    }
                                }}
                                value={handleForm.values.lazyLoad ? 'true' : 'false'}
                            >
                                <option value="false">❌ Desabilitado</option>
                                <option value="true">⚡ Habilitado</option>
                            </select>
                            {handleForm.touched.lazyLoad && handleForm.errors.lazyLoad ? (
                                <div className="invalid-feedback d-block">{handleForm.errors.lazyLoad}</div>
                            ) : null}
                        </div>
                    </div>
                </div>

                {handleForm.values.lazyLoad && (
                    <div className="row g-3">
                        <div className="col-12">
                            <h4 className="subsection-title">Configurações de Lazy Loading</h4>
                        </div>
                        <div className='col-12 col-md-6 col-lg-4'>
                            <div className="form-group">
                                <label htmlFor="lazyLoad[fetchMarginPercent]" className="form-label">
                                    Fetch Margin Percent
                                    <span className="text-muted small d-block">Margem para início do carregamento (%)</span>
                                </label>
                                <input
                                    type="number"
                                    id="lazyLoad[fetchMarginPercent]"
                                    name="lazyLoad[fetchMarginPercent]"
                                    className="form-control"
                                    value={handleForm.values.lazyLoad.fetchMarginPercent}
                                    onChange={handleForm.handleChange}
                                    placeholder="200"
                                />
                            </div>
                        </div>
                        <div className='col-12 col-md-6 col-lg-4'>
                            <div className="form-group">
                                <label htmlFor="lazyLoad[renderMarginPercent]" className="form-label">
                                    Render Margin Percent
                                    <span className="text-muted small d-block">Margem para renderização (%)</span>
                                </label>
                                <input
                                    type="number"
                                    id="lazyLoad[renderMarginPercent]"
                                    name="lazyLoad[renderMarginPercent]"
                                    className="form-control"
                                    value={handleForm.values.lazyLoad.renderMarginPercent}
                                    onChange={handleForm.handleChange}
                                    placeholder="100"
                                />
                            </div>
                        </div>
                        <div className='col-12 col-md-6 col-lg-4'>
                            <div className="form-group">
                                <label htmlFor="lazyLoad[mobileScaling]" className="form-label">
                                    Mobile Scaling
                                    <span className="text-muted small d-block">Fator de escala para mobile</span>
                                </label>
                                <input
                                    type="number"
                                    step="0.01"
                                    id="lazyLoad[mobileScaling]"
                                    name="lazyLoad[mobileScaling]"
                                    className="form-control"
                                    value={handleForm.values.lazyLoad.mobileScaling}
                                    onChange={handleForm.handleChange}
                                    placeholder="2.00"
                                />
                            </div>
                        </div>
                    </div>
                )}
            </div>

            <div className="settings-section">
                <h3 className="section-title" data-icon="🎨">Personalização e Visualização</h3>

                <div className="row g-3">
                    <div className="col-12 col-md-6">
                        <div className="form-group">
                            <label htmlFor="advertiserLabel" className="form-label">
                                Advertiser Label
                                <span className="text-muted small d-block">Rótulo para identificação do anúncio</span>
                            </label>
                            <input
                                type="text"
                                id="advertiserLabel"
                                name="advertiserLabel"
                                className={`form-control ${handleForm.touched.advertiserLabel && handleForm.errors.advertiserLabel ? 'error' : ''}`}
                                onChange={handleForm.handleChange}
                                onBlur={handleForm.handleBlur}
                                value={handleForm.values.advertiserLabel}
                                placeholder="PUBLICIDADE"
                            />
                            {handleForm.touched.advertiserLabel && handleForm.errors.advertiserLabel ? (
                                <div className="invalid-feedback d-block">{handleForm.errors.advertiserLabel}</div>
                            ) : null}
                        </div>
                    </div>

                    <div className="col-12 col-md-6">
                        <div className="form-group">
                            <label htmlFor="pageContainerSize" className="form-label">
                                Tamanho do Container da Página
                                <span className="text-muted small d-block">Largura máxima do container em px</span>
                            </label>
                            <input
                                type="text"
                                id="pageContainerSize"
                                name="pageContainerSize"
                                className={`form-control ${handleForm.touched.pageContainerSize && handleForm.errors.pageContainerSize ? 'error' : ''}`}
                                onChange={handleForm.handleChange}
                                onBlur={handleForm.handleBlur}
                                value={handleForm.values.pageContainerSize}
                                placeholder="Ex: 1200px"
                            />
                            {handleForm.touched.pageContainerSize && handleForm.errors.pageContainerSize ? (
                                <div className="invalid-feedback d-block">{handleForm.errors.pageContainerSize}</div>
                            ) : null}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default GeneralSettingsTab;